<div *ngIf="!isEditMode" (dblclick)="editModeOn()" class="row m-b-xs">
    <div class="dv-label col-sm-6" style="font-size: 13px;">{{title}}</div>

    <div class="dv-value col-sm-6 strong text-right" [ngStyle]="{'padding-right': noEdit ? '36px' : ''}">
        <span>{{value.number ? (value.number + ' ') : '-'}}</span>
        <span>{{value.number && value.selectValue ? getValueBasedOnSelectValues() : ''}}</span>
        <i *ngIf="!noEdit" (click)="editModeOn()" class="fa fa-pencil pull-right" data-toggle="tooltip" data-placement="top"
           title="Edit"></i>
    </div>
</div>

<div *ngIf="isEditMode" class="row m-b-xs editable">
    <div class="dv-label col-sm-6" style="font-size: 13px;">
        {{title}}
    </div>

    <div class="dv-value-edit dv-restrictions col-sm-6" [class.hidden]="!isEditMode">
        <input class="form-control phoneInput"
               [(ngModel)]="value.number"
               name="input"
               id="input"
               maxlength="255"
               pattern="[0-9]+">

        <select [(ngModel)]="value.selectValue" class="form-control"
                name="select" id="select">
            <option value="" hidden></option>
            <option *ngFor="let selectValue of _selectValues" [value]="selectValue.name">
                {{selectValue.displayName}}
            </option>
        </select>

        <button *ngIf="!editOnly" type="button" (click)="apply()"><i class="fa fa-check"></i></button>
        <button type="button" (click)="cancel()"><i class="fa fa-times"></i></button>
        <button type="button" (click)="delete()"><i class="fa fa-trash without-hover"></i></button>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/fields/settings-amenity-restrictions-field/settings-amenity-restrictions-field.component.html